import { useState, useEffect } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqsAPI } from '@/lib/api';
import AnimatedSection from './AnimatedSection';

const defaultFaqs = [
  { question: 'As ofertas sao confiaveis?', answer: 'Sim! Todas as ofertas sao de lojas parceiras verificadas como Shopee, Mercado Livre, Amazon e Shein. Compramos apenas de sites seguros.' },
  { question: 'Como funciona o site?', answer: 'Nos buscamos as melhores promocoes nas maiores lojas do Brasil e reunimos tudo aqui. Voce clica na oferta e e redirecionado direto para a loja oficial.' },
  { question: 'As ofertas sao atualizadas?', answer: 'Sim! Nossa equipe atualiza as ofertas varias vezes ao dia, 24 horas. Ofertas expiradas sao removidas automaticamente.' },
  { question: 'Preciso pagar algo?', answer: 'Nao! O site e 100% gratuito. Voce nao paga nada para ver as ofertas ou usar nossos servicos.' },
];

const FAQSection = () => {
  const [faqs, setFaqs] = useState(defaultFaqs);
  const [openIndex, setOpenIndex] = useState(0);

  useEffect(() => {
    faqsAPI.getAll()
      .then((res) => {
        const dbData = res.data || [];
        if (dbData.length >= 2) {
          const mapped = dbData
            .filter(f => f.is_active !== false)
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map(f => ({ question: f.question, answer: f.answer }));
          setFaqs(mapped);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <AnimatedSection>
      <section className="py-12 md:py-16 bg-[#f8fafc]">
        <div className="container mx-auto px-4 max-w-2xl">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-slate-900 mb-2">Perguntas Frequentes</h2>
            <p className="text-slate-500 text-sm">Tire suas duvidas</p>
          </div>

          <div className="space-y-3" data-testid="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl border border-slate-200 overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                  className="w-full flex items-center justify-between p-4 text-left hover:bg-slate-50 transition-colors"
                  data-testid={`faq-item-${index}`}
                >
                  <span className="font-semibold text-slate-900">{faq.question}</span>
                  {openIndex === index ? (
                    <Minus className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  ) : (
                    <Plus className="w-5 h-5 text-slate-400 flex-shrink-0" />
                  )}
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-40' : 'max-h-0'}`}>
                  <p className="px-4 pb-4 text-slate-600 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </AnimatedSection>
  );
};

export default FAQSection;
